<template>
  <div class="order-copy pop_white-s pop_bege popup_wrap" style="display:block">
    <div class="popup_in">
      <div class="popup">
        <div class="popup_close stay_close close-animate">
          <a href="javascript:void(0);" @click.prevent="closePop">
            <close />
          </a>
        </div>
        <div class="corner-top"></div>
        <div class="exists_icon">
          <LOGO />
        </div>
        <div class="pop_frame">
          <h2 class="title25" style="margin-top:20px;" v-if="typeof permOrder == 'object'">היי, בהזמנה הקבועה שלך כבר יש מוצרים... מה לעשות איתם?</h2>
          <h2 class="title25" style="margin-top:20px;" v-else>רוצה שכל המוצרים האלה יגיעו אליך כל שבוע בקבוע?</h2>
          <div class="text" v-if="typeof permOrder != 'object'">(אל דאגה את האישור הסופי צריך לתת רק בסוף התהליך)</div>
          <div class="bt_green ease" v-if="typeof permOrder == 'object'">
            <a href="#" @click.prevent="addToPermenent">הוספת המוצרים להזמנה קיימת</a>
          </div>
          <div class="bt_green ease">
            <a href="#" @click.prevent="addToPermenentClear" v-if="typeof permOrder == 'object'" >מחק וצור הזמנה קבועה חדשה</a>
            <a href="#" @click.prevent="addToPermenentClear" v-else > בטח, אני רוצה</a>
          </div>
          <div class="bt_green ease" v-if="!permOrder">
            <a href="#" @click.prevent="closePop"  > בעצם לא...</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import close from "../../assets/img/close.svg";
import LOGO from "../../assets/img/carmella.svg";
import { mapActions,mapState } from "vuex";
import OrderStatusChange from "./orderStatusChange";
export default {
  props: ["order"],
  data() {
    return {};
  },
    computed:{
      ...mapState(["permOrder"]),
    },
  methods: {
    ...mapActions(["getProductById", "updateCart", "clarCart"]),
    addToPermenent() {
      this.clarCart();
      this.$store.commit('setPermOrderEdit',true);
        let perOrder = this.$store.state.permOrder;
        let cart_items = this.$store.state.added;
        perOrder.products.map(p => {
            this.updateCart([p,true]);
            this.$store.commit('setPermenant',p);
        });
      this.order.items.map(product => {

        this.$store.commit('setPermenant',product);
          this.updateCart([product,true]);
      });

      this.closePop();
      //this.saveNewOrder();
      this.$router.push({name: 'permenent', query: {new_order : '1'}});
    },
    openCart() {
      setTimeout(() => {
        $(".cart").fadeIn(100, function() {
          $("body").addClass("noscroll");
          $(".cart_in").animate(
            {
              left: 0
            },
            600
          );
        });
      }, 500);
      this.$router.push({ path: "/" });
    },
      addToPermenentClear() {
      this.clarCart();
      this.$store.commit('setPermOrderEdit',true);
      let perOrder = this.$store.state.permOrder;

      this.$store.commit('clearPermenant');
      this.order.items.map(product => {
        this.updateCart([product,true]);
      this.$store.commit('setPermenant',product);

      });
      //return ;

      this.closePop();
      this.$router.push({name: 'permenent', query: {new_order : '1'}});

      },
      editOrder(order) {
          this.clarCart();
          this.editPerOrder = true;
          this.orderToEdit = order;
          this.$store.commit('clearPermenant');
          this.$store.commit('setPerEdit',order);
          order.products.map( product =>{
              this.$store.commit('setPermenant',product);
              this.$store.dispatch('updateCart',[product]);
          });
      },
      saveNewOrder() {
        let products_to_send = this.$store.getters.cartJSON ? this.$store.getters.cartJSON:false;

        this.$store.dispatch("updatePermanentOrder", products_to_send).then(() => {
          this.$modal.show(OrderStatusChange, {status: 1,sendToComax: false});
          this.orderToEdit = false;
          this.editPerOrder = false;
        });
      },
      closePop() {
      this.$emit('close');
    }
  },
  components: {
    LOGO,
    close
  }
};
</script>

<style scoped>
.bt_green a {
  width: 320px;
}
</style>
